import { createApi } from '@reduxjs/toolkit/query/react'
import { baseQueryWithTokenRefresh } from '../../common/baseQuery'
import { type IntegrationCatalogEntry } from '../../models/IntegrationCatalog'
import { type BaseRequest, type BaseResponse } from '../models'

const _BASE_URL = import.meta.env.REACT_APP_IAM_API_BASE_URL

export const integrationCatalogApi = createApi({
  reducerPath: 'integrationCatalogApi',
  baseQuery: baseQueryWithTokenRefresh(_BASE_URL),
  endpoints: (builder) => ({
    getIntegrationCatalog: builder.query<BaseResponse<IntegrationCatalogEntry[]>, BaseRequest>({
      query: ({ accountId }) => ({ url: `/accounts/${accountId}/integration-catalog/`, params: { effective: true } }),
    }),
  }),
})

export const { useGetIntegrationCatalogQuery } = integrationCatalogApi
